import React, { useState } from "react";
import { Box, Button, Modal,Typography, Grid } from "@mui/material";
import TicketOptions from "./ticket/TicketOptions";
// import { addToCart } from "./ticket/TicketCart"; 
import { db } from '../firebase'; // adjust path
import { doc, collection, setDoc } from 'firebase/firestore';
import { useAuth } from "../context/AuthContext";


const EventHero = ({ eventDetails }) => {
  const { currentUser } = useAuth(); // or use auth.currentUser directly
  const [openTicketModal, setOpenTicketModal] = useState(false);
  if (!eventDetails) return null;
  
  const handleOpen = () => setOpenTicketModal(true);
  const handleClose = () => setOpenTicketModal(false);

  const handleAddToCart = (ticketItem) => {
    //addToCart(ticketItem); // Your logic to update cart
    // alert(ticketItem.id);
  };
  const addOrUpdateCartItem = async (userId, ticketItem) => {
    const cartRef = doc(db, 'users', userId, 'ticketCart', ticketItem.ticketType); // ticketType as doc ID
    await setDoc(cartRef, {
      ...ticketItem,
      addedAt: new Date()
    });
  };

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 2, md: 6 }, 
        maxWidth: "1200px", margin: "auto",           
      }}
    >
      <Grid container spacing={4} alignItems="center"  columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* Left Section - eventDetails Details */}
        <Grid item xs={12} size={{ xs: 12, sm: 6, md: 6 }} >
          <Typography variant="title2" color="textSecondary">
            { new Date(eventDetails.eventStartDate.seconds * 1000).toLocaleString()} , {eventDetails.eventLocation}, {eventDetails.eventCity}
          </Typography>
          <Typography variant="h3"  fontWeight="bold" gutterBottom>
            {eventDetails.eventName}
          </Typography>          
          <Typography variant="body1" color="textSecondary" sx={{ mt: 2, mb: 4 }}>
            {eventDetails.eventDescription}
          </Typography>
          <Button variant="contained" color="primary" size="large"  onClick={handleOpen}>
            Get Ticket
          </Button>
        </Grid>

        {/* Right Section - Event Cover Image */}
        <Grid item xs={12} size={{ xs: 12, sm: 6, md: 6 }} >
          <Box
            component="img"
            src={eventDetails.eventImage}
            alt={eventDetails.eventName}
            sx={{
              width: "100%",
              height: "auto",
              maxHeight: "700px",
              borderRadius: 2,
              objectFit: "cover",
            }}           
          />
        </Grid>
      </Grid>

      {/* Modal for TicketOptions */}
      <Modal open={openTicketModal} onClose={handleClose}>
        <Box
          sx={{
            width: 600,
            bgcolor: "background.paper",
            p: 4,
            mx: "auto",
            my: "10%",
            borderRadius: 2,
          }}
        >
          <TicketOptions 
            eventId={eventDetails.eventId}
            eventData={eventDetails} 
            onClose={handleClose}
            onAddToCart={addOrUpdateCartItem} />
        </Box>
      </Modal>

    </Box>
  );
};

export default EventHero;

